export default __webpack_public_path__ + "static/media/dancing-script-latin-700.6620ab66.woff";